
export default [

    {
        path: '*',
        name: 'NotFound',
        component: () => import('@/page/notFound/index.vue'),
        children: [
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/notFound.js